// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".etapa .MuiButtonBase-root.MuiTab-root.MuiTab-textColorInherit {\n  min-width: 300px; }\n", "",{"version":3,"sources":["webpack://./src/modules/brasilMais/visita.scss"],"names":[],"mappings":"AAEA;EAEK,gBAAgB,EAAA","sourcesContent":["@import \"../../components/colorPallete.scss\";\n\n.etapa {\n\t& .MuiButtonBase-root.MuiTab-root.MuiTab-textColorInherit {\n\t    min-width: 300px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
